import {useEffect, useState} from 'react';
import {
    GetAllByWorkShiftId,
    AddUserWithWorkShiftId,
    DeleteUserFromWorkShift,
} from '../../../../../reduxToolkit/CompanyWorkShift/CompanyWorkShiftApi';
import { useDispatch } from 'react-redux';
import {errorMsg, userListToLabelEmailPhoneValue} from "../../../../../Apis/functions";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";
import {PersonChipBlack} from "../../../../../components/buttons/IconButtons";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: FullStack
 * @Email: kpozos@ibl.mx
 *  @param id
 */
const ShiftManagementApp = ({ onHide, selectedId, setModified }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [results, setResults] = useState([]);

    useEffect(() => {
        if(selectedId) getData();
    }, [selectedId])

    const getData = () => {
        dispatch(GetAllByWorkShiftId(selectedId)).then(
            ({payload: {data: {success, data },},}) =>
            {
                if (success === true) {
                    setResults(userListToLabelEmailPhoneValue(data || [], "userId", false, PersonChipBlack))
                }
            },
        );
    }

    // Remove User from selection
    const handleDelete = (user) => {
        const userIds = [user];
        const workShiftIds = [selectedId];
        const body = {
            userIds,
            workShiftIds,
        };
        dispatch(DeleteUserFromWorkShift(body)).then(({payload: {data: {success, code },},}) => {
                if (success === true) {
                    setModified(true);
                    getData();
                }else errorMsg(code)
            },
        );
    };

    // Add User to WorkShift
    const handleAdd = (items) => {
        const all_user = items?.map((item) => item?.id);
        if (all_user?.length > 0) {
            dispatch(AddUserWithWorkShiftId({ id: selectedId, all_user })).then(({payload: {data: {success},},}) => {
                    if (success === true) {
                        toast.success(t('has_been_added_successfully')); // Show success message
                        setModified(true);
                        onHide();
                    }
                },
            );
        }
    };

    return {
        t, // Translation
        handleDelete,
        handleAdd,
        selectedEmployee: results,
    };
};

export default ShiftManagementApp;
